<template>
    <div id="anchor-zig-zag" :class="zigzag.fragmentClasses" class="row">
        <div class="col-12 p-md-0" v-for="(zigZag, index) in zigzag.zigZagItems">
            <div
                :class="`card ob1-push ob1-push-zigzag ob1-push-shadow-right ${index === zigzag.zigZagItems.length-1? additionalClasses:''} ${definePictureLayout(index)}`">
            <div class="card-item">
                <div class="card-header" v-if="zigZag.image"
                     :class="index === zigzag.zigZagItems.length-1? additionalClasses:''">
                        <ob1-picture :cssClasses="'card-img-top'" :visual="zigZag.image"></ob1-picture>
                    </div>
                    <div class="card-header video-height" v-if="zigZag.video">
                        <video-container :src="zigZag.video" />
                    </div>
                </div>
                <div class="card-item">
                    <div class="card-body" v-for="item in zigZag.body">
                        <h3 class="card-title" data-clamp="2">{{ item.title }}</h3>
                        <p class="card-text" v-html="item.textHtml"></p>
                        <p class="py-0 card-btn" v-if="item.btnLabel !== ''">
                            <a :href="item.btnLink"
                               :data-oevent-category="item.btnTms.tagZone"
                               :data-oevent-action="item.btnTms.tagName"
                               :data-oevent-label="item.btnTms.tagTarget"
                               class="btn btn-secondary"
                            >{{ item.btnLabel }}</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VideoContainer from "../../components/VideoContainer.vue";

export default {
    name: "push-zig-zag",
    components: {
        VideoContainer
    },
    props: {
        zigzag: {
            type: Object,
            required: true
        },
        additionalClasses: {
            type: String,
            default: ""
        }
    },
    methods: {
        definePictureLayout(index) {
            const oddClass = this.zigzag?.firstIsEven ? "ob1-push-zigzag-even ob1-push-md-shadow-left" : "ob1-push-zigzag-odd"
            const evenClass = this.zigzag?.firstIsEven ? "ob1-push-zigzag-odd" : "ob1-push-zigzag-even ob1-push-md-shadow-left"
            const startIndex = this.zigzag?.firstIsEven ? 0 : 1
            const computedIndex = index + startIndex
            const isEven = computedIndex % 2 === 0
            return isEven ? evenClass : oddClass
        }
    }
}
</script>

<style scoped lang="scss">
@import 'ob1_common';

.ob1-push.ob1-push-zigzag .card-header.video-height {
    height: px-to-rem(280);
}

.iframe-size {
    width: 100%;
    height: 100%;
}
</style>
